import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getNiceDate } from '@iotv/datamodel';
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { ComponentMode } from '../../types/AppTypes';
const debug = process.env.REACT_APP_DEBUG && false;
const mode = ComponentMode.READONLY;
const updateKV = () => { };
export const ReadOnlyList = ({ matchedPrimary, objects, viewDefinition }) => {
    //const classes = useStyles();
    const classes = {};
    debug && console.log('ReadOnlyList gets', { viewDefinition });
    const getHeaderCells = (viewDefinition) => {
        debug && console.log('Something is undfined', Object.entries(viewDefinition) === undefined);
        return Object.values(viewDefinition).map((viewKeyDefinition) => (_jsx(TableCell, { className: classes.tableCellNoPadding, align: 'left', children: viewKeyDefinition.label }, viewKeyDefinition.key)));
    };
    const switchOnAttTypeView = (rowObject, viewKeyDefinition) => {
        const value = rowObject[viewKeyDefinition.key];
        switch (viewKeyDefinition.type) {
            // case AppValueTypes.ENUM: return <EnumComponent {...{ matchedPrimary: rowObject, viewKeyDefinition, mode, updateKV }}></EnumComponent>
            // case AppValueTypes.BOOLEAN: return <BooleanComponent {...{ matchedPrimary: rowObject, viewKeyDefinition, mode, updateKV }}></BooleanComponent>;
            case AppValueTypes.DATE:
                return value ? getNiceDate(new Date(value).valueOf(), { dateStyle: 'short' }) : value;
            default:
                return viewKeyDefinition.valueGetter ? viewKeyDefinition.valueGetter(value, rowObject) : value;
        }
    };
    const getAttributeCell = (matchedPrimary, rowObject, viewKeyDefinition) => {
        return (_jsx(TableCell, { className: classes.tableCellNoPadding, align: "left", children: switchOnAttTypeView(rowObject, viewKeyDefinition) }, `${matchedPrimary?.sk}_${rowObject.sk}_${viewKeyDefinition.key}-edit`));
    };
    const getObjectRow = (object, i) => {
        return (_jsx(TableRow, { children: Object.entries(viewDefinition).map(([key, viewKeyDefinition], i) => getAttributeCell(matchedPrimary, object, viewKeyDefinition)) }, i));
    };
    return (_jsxs(Table, { children: [_jsx(TableHead, { children: _jsx(TableRow, { children: getHeaderCells(viewDefinition) }) }), _jsx(TableBody, { children: objects.map((object, i) => getObjectRow(object, i)) })] }));
};
